export enum Severity {
  FATAL = 'fatal',
  CRITICAL = 'critical',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug',
  LOG = 'log',
}
